import { Group, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const ResumePage = () => {
    const { t } = useTranslation();

    return (
        <div style={{ padding: '1rem' }}>
            <Group justify='space-between'>
            <Title order={2}>{t('create_resume')}</Title>
            </Group>
        </div>
    )
}

export default ResumePage;